import React from 'react';
import styles from './ProfileColumns.module.css';

interface ProfileColumnsProps {
  children: React.ReactNode;
  className?: string;
}

const ProfileColumns: React.FC<ProfileColumnsProps> = ({ children, className }) => (
  <div className={`${styles['profile-columns']}${className ? ` ${className}` : ''}`}>
    {children}
  </div>
);

export default ProfileColumns;
